import { useNavigate } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import OrderForm from '../components/orders/OrderForm';
import orderService from '../utils/orderService';
import { useTranslation } from 'react-i18next';

const OrderNew = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    const created = await orderService.create(data);
    navigate(`/dashboard/orders/${created.id}`);
  };

  return (
    <section className="col-span-1 md:col-span-10 p-4 md:py-6">
      <div className="rounded-lg border border-slate-200 bg-slate-50/70 p-4 shadow-sm md:p-6">
        <div className="mb-6 flex flex-col justify-between gap-4 rounded-lg bg-white p-5 text-left shadow-sm md:flex-row md:items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-emerald-700">
              {t('dashboard.orders.label')}
            </p>
            <h2 className="mt-2 text-3xl font-semibold text-[#00595A]">
              {t('dashboard.orders.newTitle')}
            </h2>
            <p className="mt-2 text-sm text-slate-500">
              {t('dashboard.orders.newSubtitle')}
            </p>
          </div>
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded bg-[#00595A] text-white shadow-sm">
            <FaPlus className="h-6 w-6" />
          </div>
        </div>

        <div className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm md:p-6">
          <OrderForm
            onSubmit={handleSubmit}
            onCancel={() => navigate('/dashboard/orders')}
          />
        </div>
      </div>
    </section>
  );
};

export default OrderNew;
